<template>
  <v-app>
    <div
      style="height:100vh;margin-left:56px;display:flex;flex-direction: row;padding:.4vh;align-items:center"
    >
      <slot />
    </div>
  </v-app>
</template>

<script>
export default {
  name: "HiPage"
};
</script>

<style scoped></style>
